module.exports = __webpack_public_path__ + "static/media/  (156).066d6536.jpg";